export default function BuildReturn(success, title = '', message = '', obj) {
    const object = {
        success: success,
        title: title,
        message: message,
        object: obj
    }

    return object
}